import axios, { AxiosResponse } from "axios";
import { TGetHistoryData } from "./types";
import { RESOURCE_ENDPOINT } from "./config";
import { setApiUrl } from "api/helpers";

export const getChatHistory = async (conversationId: string): Promise<AxiosResponse<TGetHistoryData[]>> => {

  const url = setApiUrl(RESOURCE_ENDPOINT + `/${conversationId}`)
  return axios.get(url)
}